import React, { useState, useEffect } from "react";
import { AppContext } from "../utilities/context";
import { IntlProvider } from "react-intl";
import axios from "axios";
import { Outlet } from "react-router-dom";
import Spanish from "../lang/es.json";
import English from "../lang/en.json";
import Portuguese from "../lang/pt.json";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

axios.defaults.withCredentials = true;

const App = () => {
  const languageMap = {
    es: Spanish,
    "es-ar": Spanish,
    "es-mx": Spanish,
    pt: Portuguese,
    "pt-br": Portuguese,
    "pt-pt": Portuguese,
  };

  const locale = navigator.language.toLowerCase();
  const langCode = locale.split("-")[0];
  const lang = languageMap[locale] || languageMap[langCode] || English;

  const [user, setUser] = useState(null);

  const updateUserState = (payload) => {
    setUser(payload);
  };

  useEffect(() => {
    // getUser();
  }, []);

  return (
    <AppContext.Provider value={{ user, updateUserState }}>
      <IntlProvider locale={locale} messages={lang}>
        <Outlet />
      </IntlProvider>
    </AppContext.Provider>
  );
};

export default App;
